<template>
  <div class="customer-info" dir="rtl">
    <div class="login-card-outer">
      <div

      >
        <div class="login-card mt-5">
          <div v-if="level==1">
            <strong class="title">
              {{$t('techName')}}: {{profile.UserName}}
            </strong>
          </div>
          <div>
            <strong >
              {{branch_name}}
            </strong>
          </div>
          <div class="relative">

            <!--            <v-icon>-->
            <!--              mdi-cellphone-iphone-->
            <!--            </v-icon>-->
            <v-text-field
              :placeholder="$t('customerMobileNo')"
              v-model="mobile"

              outlined
            ></v-text-field>

          </div>
          <label v-if="fullName2!='' && level==1">
            {{fullName2}}
          </label>
          <div v-if="level==2" >
            <div>
              <div
                class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                <div class="v-input__control">
                  <div class="v-input__slot">
                    <fieldset aria-hidden="true">
                      <legend style="width: 0px;"><span>&ZeroWidthSpace;</span></legend>
                    </fieldset>
                    <div class="v-text-field__slot">
                      <input :placeholder="$t('fullName')" v-model="fullName2" id="input-67" type="text"></div>
                    <div class="v-input__append-inner">
                      <div class="v-input__icon v-input__icon--append"><i aria-hidden="true"
                                                                          class="v-icon notranslate mdi mdi-account theme--light"></i>
                      </div>
                    </div>
                  </div>
                  <div class="v-input__slot">
                    <fieldset aria-hidden="true">
                      <legend style="width: 0px;"><span>&ZeroWidthSpace;</span></legend>
                    </fieldset>
                    <div class="v-text-field__slot">
                      <input :placeholder="$t('nationalCode')" v-model="nationalCode" id="input-68" type="text"></div>
                    <div class="v-input__append-inner">
                      <div class="v-input__icon v-input__icon--append"><i aria-hidden="true"
                                                                          class="v-icon notranslate mdi mdi-account theme--light"></i>
                      </div>
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <div class="v-messages theme--light">
                      <div class="v-messages__wrapper"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div>

          <button class="btn login-btn" v-on:click="login()" v-if="level==2">
            {{$t('register')}}
          </button>
<!--          <button class="btn login-btn footer_btn" v-on:click="go_to_categories()" v-if="user_registered">-->
<!--            بعدی-->
<!--          </button>-->
          <div v-if="level==1">
            <div v-on:click="level=2" v-if="not_register">
              {{$t('customerNotRegistered')}}
            </div>
          </div>
          <v-btn class="enter-btn "  style="width: 100%;margin-top: 5px" v-if="user_registered" v-on:click="go_to_categories()">{{ $t('insert_info') }}</v-btn>

        </div>
      </div>

    </div>
<!--    <div class="footer v-footer&#45;&#45;fixed">-->
<!--    </div>-->
  </div>

</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        mobile: '',
        fullName2: '',
        lastfullName2: '',
        customer_name: '',
        branch_name: localStorage.getItem('branch_name'),
        password: '',
        profile:  JSON.parse(localStorage.getItem('profile')),
nationalCode:'',
        valid: true,
        not_register: false,
        user_registered: false,
        level: 1,
        rules: {
          required: value => !!value || this.$t('required'),
          // fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          // PersianFullName: value => {
          //   const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاكتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
          //   return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          // },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('mobileNotCorrect')
          },
        },
      }
    },
watch: {
      mobile: function () {
        this.not_register = false
        this.user_registered = false
        this.fullName2 = ''
        this.lastfullName2 = ''

        console.log('mobile changed')
        if (this.mobile.length == 11 && this.level == 1) {
          this.login()
        }
      },
      fullName2: function () {
      if (this.level == 2) {
        var pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاكتنكيمکيگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
        // return pattern.test(last_char) || 'نام و نام خانوادگی فارسی نیست.'
        if (this.fullName2 != '') {
          if (!pattern.test(this.fullName2)) {
            this.fullName2 = this.lastfullName2
          } else {
            this.lastfullName2 = this.fullName2
          }
        }
      }
      }
      // }
    },
    methods: {
      login () {
        // this.mobile = this.persian_to_english(this.mobile)
        var eddited_mobile = this.persian_to_english(this.mobile)
        if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
          eddited_mobile="0"+eddited_mobile
        }
        var self = this
        if (this.level == 1) {
          const send_data = {
            Phone: eddited_mobile,
          }
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response', response)
                self.user_registered = true
                self.fullName2 = response.data.msg
                // self.level = 2;
              } else {
                self.not_register = true
                self.user_registered = false

              }
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
        } else if (this.level == 2) {
          var eddited_mobile = this.persian_to_english(this.mobile)
          if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
            eddited_mobile="0"+eddited_mobile
          }
           eddited_mobile = eddited_mobile.substring(1)
          self.nationalCode = this.persian_to_english(self.nationalCode);
          eddited_mobile = '+98' + eddited_mobile
          if (self.mobile != '' && self.fullName2 != '') {
            const send_data = {
              Phone: eddited_mobile,
              Password: self.password,
              NationalCode: self.nationalCode,
              OsName: 'win',
              AppNo: '3',
              OsVersion: '5',
              DeviceModel: 'android',
              UserName: self.fullName2,
              PartyId: localStorage.getItem('party_id'),

            }
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/CustomerRegistration', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log('response login', response)

                  var passing_data = JSON.parse(localStorage.getItem('request_data'))
                  passing_data.customer_mobile = eddited_mobile
                  passing_data.customer_name = self.fullName2
                  localStorage.setItem('request_data', JSON.stringify(passing_data))
                  self.user_registered = true;
                  self.$router.push({ name: 'Categories', params: { passing_data: self.passing_data } })
                } else {
                  bus.$emit('show_toast', [1500, response.data.msg])
                }
              }).catch(e => {
              self.errors.push(e)
            })
          }
        }
        if (this.mobile == '') {
          this.errors.push(this.$t('insertCorrectMobileNo'))
        }
        if (this.fullName2 == '') {
          this.errors.push(this.$t('insertFullName'))
        }
      },

      go_to_categories () {
        // var PassingData = {'on_site_service':OnSite}
        if (this.fullName2 != '') {
          var eddited_mobile = this.persian_to_english(this.mobile)
          if(!eddited_mobile.startsWith(0) && eddited_mobile.length==10){
            eddited_mobile="0"+eddited_mobile
          }
          eddited_mobile = eddited_mobile.substring(1)

          eddited_mobile = '+98' + eddited_mobile
          var passing_data = JSON.parse(localStorage.getItem('request_data'))
          passing_data.customer_mobile = eddited_mobile
          passing_data.customer_name = this.fullName2
          localStorage.setItem('request_data', JSON.stringify(passing_data))

          this.$router.push({ name: 'Categories', params: { passing_data: this.passing_data } })
        } else {
          bus.$emit('show_dialog', [this.$t('error'), this.$t('insertCustomerMobileNo')])
        }
      }
    }
  }
</script>
